import React, { useState } from 'react';

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    estado: '',
    cidade: '',
    assunto: '',
  });

  const WHATSAPP_NUMBER = '5567998238156';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { nome, telefone, email, estado, cidade, assunto } = formData;
    
    let text = `*Novo Contato via Site:*\n\n`;
    text += `*Nome:* ${nome}\n`;
    text += `*Telefone:* ${telefone}\n`;
    text += `*Email:* ${email}\n`;
    text += `*Estado:* ${estado}\n`;
    text += `*Cidade:* ${cidade}\n\n`;
    text += `*Assunto:* ${assunto}\n\n`;

    const encodedText = encodeURIComponent(text);

    const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedText}`;

    window.open(whatsappLink, '_blank');

    setFormData({
        nome: '',
        telefone: '',
        email: '',
        estado: '',
        cidade: '',
        assunto: '',
    });
  };

  return (
    <div className="contato">
      <h2>Fale Conosco</h2>
      <p>Preencha o formulário e entraremos em contato para um atendimento personalizado.</p>

      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          name="nome"
          placeholder="Seu Nome Completo"
          value={formData.nome}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="telefone"
          placeholder="Seu Telefone (DDD + Número)"
          value={formData.telefone}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Seu email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <select
          name="estado"
          value={formData.estado}
          onChange={handleChange}
          required
        >
          <option value="" disabled>Qual seu estado?</option>
          <option value="AC">Acre</option>
          <option value="AL">Alagoas</option>
          <option value="AP">Amapá</option>
          <option value="AM">Amazonas</option>
          <option value="BA">Bahia</option>
          <option value="CE">Ceará</option>
          <option value="DF">Distrito Federal</option>
          <option value="ES">Espírito Santo</option>
          <option value="GO">Goiás</option>
          <option value="MA">Maranhão</option>
          <option value="MT">Mato Grosso</option>
          <option value="MS">Mato Grosso do Sul</option>
          <option value="MG">Minas Gerais</option>
          <option value="PA">Pará</option>
          <option value="PB">Paraíba</option>
          <option value="PR">Paraná</option>
          <option value="PE">Pernambuco</option>
          <option value="PI">Piauí</option>
          <option value="RJ">Rio de Janeiro</option>
          <option value="RN">Rio Grande do Norte</option>
          <option value="RS">Rio Grande do Sul</option>
          <option value="RO">Rondônia</option>
          <option value="RR">Roraima</option>
          <option value="SC">Santa Catarina</option>
          <option value="SP">São Paulo</option>
          <option value="SE">Sergipe</option>
          <option value="TO">Tocantins</option>
        </select>
        {formData.estado && (
          <input
            type="text"
            name="cidade"
            placeholder="Sua Cidade"
            value={formData.cidade}
            onChange={handleChange}
            required
          />
        )}

        <select
          name="assunto"
          value={formData.assunto}
          onChange={handleChange}
          required
        >
          <option value="" disabled>Selecione um Assunto</option>
          <option value="Orcamento">Orçamento / Cotação</option>
          <option value="Duvida">Dúvida sobre Produtos</option>
          <option value="Outros">Outros Assuntos</option>
        </select>
        
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default Contato;